module.exports = __webpack_public_path__ + "static/media/buy_finish_service_make_4.9616a85f.jpg";